module.exports = __webpack_public_path__ + "img/faqs_layout3.30dff2c4.png";